/**
 * @Category React Hook function
 * Provide single source to manage application static menus items
 * 
**/


export default function useMenus() {
    
    
    return {
	navbarTopRight: [],
	navbarTopLeft: [],
	navbarSideLeft: [
  {
    "to": "/home",
    "label": "Home",
    "icon": "pi pi-home",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/nozone",
    "label": "Admin",
    "icon": "pi pi-angle-double-right",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/register",
        "label": "Register",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/mandateworld/listadmin",
        "label": "Mandate List",
        "icon": "pi pi-book",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/loanamort/listadmin",
        "label": "Payment Schedule List",
        "icon": "pi pi-bookmark",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/mandateverify",
        "label": "Mandate Verify",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/debitpresentation",
        "label": "Debit Presentation",
        "icon": "pi pi-calendar",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/debitverify",
        "label": "Payment Verify",
        "icon": "pi pi-wallet",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/loanproduct",
        "label": "Loan Product",
        "icon": "pi pi-cog",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/vendordocs/listadmin",
        "label": "Documents Uploaded",
        "icon": "pi pi-angle-double-up",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/users/kycupdate",
        "label": "Kyc Status",
        "icon": "pi pi-book",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/chargessummary",
        "label": "Charges Summary",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/creditrequest",
        "label": "Credit Request",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/permissions",
        "label": "Permissions",
        "icon": "pi pi-lock",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/roles",
        "label": "Roles",
        "icon": "pi pi-ticket",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/users",
        "label": "Users",
        "icon": "pi pi-user-plus",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/vendors",
        "label": "Vendors",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/chargestbl",
        "label": "Charge Setup",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/wallet",
        "label": "Wallet",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/paymentdoc",
        "label": "Recharge",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      }
    ]
  },
  {
    "to": "/kyc",
    "label": "Kyc Update",
    "icon": "pi pi-camera",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/creditrequest/add",
    "label": "Credit Report",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/createmandate",
    "label": "Create Mandate",
    "icon": "pi pi-calculator",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/loanamort/listvendor",
    "label": "Loan Amort/Transaction",
    "icon": "pi pi-table",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/mandateworld",
    "label": "Loan Mandates",
    "icon": "pi pi-calendar",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/vendordocs",
    "label": "Document Upload",
    "icon": "pi pi-angle-double-up",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/paymentdoc/add",
    "label": "Cibil Recharge",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/creditrequest/listvendor",
    "label": "List Reports",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/cibil_update",
    "label": "Cibil Update",
    "icon": "pi pi-angle-double-right",
    "iconcolor": "",
    "target": "",
  }
],
	gender: [    
{value: "male", label: "Male"},
	{value: "female", label: "Female"}
    ],
	frequency: [    
{value: "DAIL", label: "Daily"},
	{value: "WEEK", label: "Weekly"},
	{value: "MNTH", label: "Monthly"},
	{value: "QURT", label: "Quarterly"},
	{value: "MIAN", label: "Half Yearly"},
	{value: "YEAR", label: "Yearly"},
	{value: "BIMN", label: "Bi Monthly"},
	{value: "ADHO", label: "Lumpsum"}
    ],
	accounttype: [    
{value: "Saving", label: "Saving"},
	{value: "Current", label: "Current"}
    ],
	authtype: [    
{value: "all", label: "All"},
	{value: "netBanking", label: "NetBanking"}
    ],
	frequency2: [    
{value: "DAIL", label: "Daily"},
	{value: "WEEK", label: "Weekly"},
	{value: "MNTH", label: "Monthly"},
	{value: "QURT", label: "Quarterly"},
	{value: "MIAN", label: "HalfYearly"},
	{value: "YEAR", label: "Yearly"},
	{value: "BIMN", label: "BiMonthly"},
	{value: "ADHO", label: "Lumpsum"}
    ],
	authtype2: [    
{value: "all", label: "All"},
	{value: "netBanking", label: "Netbanking"}
    ],
	gender2: [    
{value: "Male", label: "Male"},
	{value: "Female", label: "Female"}
    ],
	accountStatus: [    
{value: "Active", label: "Active"},
	{value: "Pending", label: "Pending"}
    ],
	doctitle: [    
{value: "AADHAR-FRONT", label: "Aadhar-Front"},
	{value: "ADHAR-BACK", label: "Adhar-Back"},
	{value: "PAN", label: "Pan"},
	{value: "VOTERID (Optional)", label: "Voterid (Optional)"},
	{value: "TRADE LICENCE (Optional)", label: "Trade Licence (Optional)"},
	{value: "GST (Optional)", label: "Gst (Optional)"}
    ],
        exportFormats: {
            print: {
                label: 'Print',
                icon: 'pi pi-print',
                type: 'print',
                ext: '',
            },
            pdf: {
                label: 'Pdf',
                icon: 'pi pi-file-pdf',
                type: 'pdf',
                ext: 'pdf',
            },
            excel: {
                label: 'Excel',
                icon: 'pi pi-file-excel',
                type: 'excel',
                ext: 'xlsx',
            },
            csv: {
                label: 'Csv',
                icon: 'pi pi-table',
                type: 'csv',
                ext: 'csv',
            },
        },
    }
}